const bookingRoutes = [
  {
    path: '/teetimes',
    name: 'teeTimes',
    component: () => import('./clubHouse/clubTeeTimes.vue'),
    meta: {
      requiresAuth: true,
      hideHomeClub: true,
      noAutoScroll: true,
    },
    props: true,
  },
  {
    path: '/teetimes/:clubId',
    name: 'heyImAnOldRedirectJustInCase',
    redirect: to => ({ name: 'teeTimes', query: { clubid: to.params.clubId } }),
  },
];

export default bookingRoutes;
